import buildService, { NoParams } from 'common/utils/build-service'
import { POST } from 'common/requests'

export default buildService<NoParams, unknown, unknown, unknown>({
  type: POST,
  constantsPrefix: 'BOOKMARK',
  http: {
    createApiUrlSuffix: () => '/rpc/bookmark',
    headers: {
      Accept: 'application/json',
    },
  },
})
